import { EditContractMainData } from '../editContract/editContractMainData';
import companyDefaultImage from '../../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../../entityImage/entityImageConfig';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { CardMedia, Grid, Box, Typography } from '@mui/material';
import ContractRenewStatus from '../contractRenewStatus';
import { FormatDate } from '../../../utils/formatDate';
import '../../../css/contracts/contractInfoData.css';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import Iconify from '../../Iconify';

const ContractMainData = () => {
    const contractDetailsData = useSelector((state) => state.ContractDetailsData);
    const hasContractUpdatePermission = useHasPermission('contract_update');

    const [openEditContract, setOpenEditContract] = useState(false);

    return (
        <Grid container spacing={3} className='contractData_main_grid'>
            <Grid item xs={12} md={4}>
                <CardMedia
                    component="img"
                    height="263"
                    image={entityGridPhotoUrl(contractDetailsData?.company, 'company', { fallback: companyDefaultImage })}
                    className="machineImageActions_card_media"
                />
            </Grid>
            <Grid item xs={12} md={8}>
                <Box className='contractData_box'>
                    <Box className='contractData_edit_box'>
                        <Box className='contractData_title'>
                            {contractDetailsData?.title}
                            {contractDetailsData?.contract_number && (
                                <Box className='contractData_number'>
                                    <Iconify className='InvoiceDetailsHeader_title' icon="tabler:number" />
                                    {contractDetailsData.contract_number}
                                </Box>
                            )}
                        </Box>
                        {hasContractUpdatePermission && <Iconify className='contractData_edit_icon' icon="ic:outline-edit" onClick={() => setOpenEditContract(true)} />}
                    </Box>
                    <Box className='contractData_info_box'>
                        <Box className='contractData_icon_title_response_box'>
                            <Iconify icon="material-symbols:date-range-outline-rounded" width="32px" />
                            <Box className='contractData_response_box'>
                                <Typography className='contractData_text_label'>Date:</Typography>
                                <Typography className='contractData_text_value'>{FormatDate(contractDetailsData?.contract_date?.[contractDetailsData?.contract_date.length - 1]?.start_date)} - {contractDetailsData?.contract_date?.[0]?.end_date ? FormatDate(contractDetailsData?.contract_date?.[0]?.end_date) : 'Ouvert'}</Typography>
                            </Box>
                        </Box>
                        <Box className='contractData_icon_title_response_box'>
                            <Iconify icon="el:person" width="32px" />
                            <Box className='contractData_response_box'>
                                <Typography className='contractData_text_label'>Suivi des visites :</Typography>
                                {contractDetailsData?.visit_count ?
                                    <Typography className='contractData_text_value'>{contractDetailsData?.visit_count} {contractDetailsData?.visit_frequency}</Typography>
                                    :
                                    <Typography className='contractData_text_label'>--</Typography>
                                }
                            </Box>
                        </Box>
                        <Box className='contractData_icon_title_response_box'>
                            <Iconify icon="system-uicons:reset" width="32px" />
                            <Box className='contractData_response_box'>
                                <Typography className='contractData_text_label'>Renouvellement automatique :</Typography>
                                <ContractRenewStatus status={contractDetailsData?.auto_renew} />
                            </Box>
                        </Box>
                        {contractDetailsData?.auto_renew &&
                            <Box className='contractData_icon_title_response_box'>
                                <Box className='contractData_icon_title_box'>
                                    <Iconify icon="lucide:clock-fading" width="32px" />
                                    <Typography className='contractData_text_label'>Délai de préavis de non renouvellement :</Typography>
                                </Box>
                                <Typography className='contractData_text_value'>
                                    {contractDetailsData?.rappel_frequency === 3 ?
                                        '3 mois avant' : contractDetailsData?.rappel_frequency === 6 ?
                                            '6 mois avant' : contractDetailsData?.rappel_frequency === 8 ?
                                                '8 mois avant' : 'Aucun'
                                    }
                                </Typography>
                            </Box>
                        }
                    </Box>
                </Box>
                {openEditContract &&
                    <EditContractMainData
                        openEditContract={openEditContract}
                        setOpenEditContract={setOpenEditContract}
                    />
                }
            </Grid>
        </Grid>
    );
}

export default ContractMainData;